import React from 'react'
import ShareModalContent from '../shareModal/ShareModalContent'
import ShareError from './modals/ShareError'
import AloModal from '../AloModal'
import ReportPlaylistModal from './modals/ReportPlaylistModal'
import EditPlaylistModal from './modals/EditPlaylistModal'
import PropTypes from 'prop-types'
import AloButton from '../AloButton'
import { unlock_membership_event } from 'gtm/pushEvents'
import { ShareIcon } from 'images/latest'
import { DeleteIcon } from 'images/latest'
import { EditIcon } from 'images/latest'
import { DuplicateIcon } from 'images/latest'
import './PlaylistEdit.scss'
import { PlaylistMenus } from './PlayListMenus'

class PlaylistEdit extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      openModal: '',
      duplicating: false
    }

    this.openModal = this.openModal.bind(this)
    this.hideModal = this.hideModal.bind(this)
  }

  openModal(modal) {
    this.setState({ openModal: modal })
  }

  hideModal() {
    this.setState({ openModal: null })
  }

  generateMenuOptions() {
    const {
      playlist,
      userIsAdmin,
      userIsAuthor,
      onDelete,
      toggleFeatured,
      onDuplicated,
      deleting
    } = this.props

    let menuOptions = [
      {
        text: 'Share',
        icon: ShareIcon,
        nonActive: playlist.private,
        handleClick: () => {
          if (playlist.private) {
            this.openModal('shareError')
          } else {
            this.openModal('share')
          }
        }
      },
      {
        text: 'Duplicate',
        icon: DuplicateIcon,
        processing: this.state.duplicating,
        handleClick: () => {
          this.setState({ duplicating: true })
          playlist.duplicate().then((duplicated) => {
            this.setState({ duplicating: false })
            onDuplicated(duplicated.data)
          })
        }
      }
    ]

    if (userIsAuthor) {
      menuOptions.push(
        {
          text: 'Edit',
          icon: EditIcon,
          handleClick: () => {
            this.openModal('edit')
          }
        },
        { text: 'Delete', 
          icon: DeleteIcon,
          handleClick: onDelete, processing: deleting }
      )
    }

    return menuOptions
  }

  renderOptions() {
    const { playlist } = this.props

    const menuOptions = this.generateMenuOptions()

    return (
      <React.Fragment>
        <PlaylistMenus menuOptions={menuOptions}/>
        <AloModal
          show={this.state.openModal === 'share'}
          onHide={this.hideModal}
        >
          <ShareModalContent
            item='Playlist'
            playlist={playlist}
            urlToShare={`${window.location.origin}/playlists/${playlist.uuid}`}
            shareCaption='Recipients of this link will only be able to view the playlist.
          They will have no editing abilities.'
            onHide={this.hideModal}
          />
        </AloModal>
        <ReportPlaylistModal
          show={this.state.openModal === 'report'}
          onHide={this.hideModal}
          playlist={playlist}
        />
        <EditPlaylistModal
          show={this.state.openModal === 'edit'}
          onHide={this.hideModal}
          onPlaylistUpdate={this.props.onPlaylistUpdate}
          playlist={playlist}
        />
        <ShareError
          show={this.state.openModal === 'shareError'}
          onHide={this.hideModal}
        />
      </React.Fragment>
    )
  }

  renderView() {
    if (!this.props.signedIn) {
      return (
        <a
          className='btn alo-button'
          href='/surveys/onboarding'
          onClick={() => {
            unlock_membership_event('playlist')
          }}
        >
          Start Practicing
        </a>
      )
    } else {
      let button
      if (!this.props.userIsAuthor) {
        if (this.props.playlist.following) {
          button = (
            <AloButton
              hoverableText='Remove From My Playlists'
              onClick={this.props.toggleFollowing}
            >
              Saved To My Playlists
            </AloButton>
          )
        } else {
          button = (
            <AloButton onClick={this.props.toggleFollowing}>
              Add To My Playlists
            </AloButton>
          )
        }
      }
      return (
        <React.Fragment>
          {button}
          {this.renderOptions()}
        </React.Fragment>
      )
    }
  }

  render() {
    return <div className='PlaylistEdit'>{this.renderView()}</div>
  }
}

PlaylistEdit.propTypes = {
  playlist: PropTypes.object,
  userIsAdmin: PropTypes.bool,
  userIsAuthor: PropTypes.bool,
  onDelete: PropTypes.func,
  toggleFeatured: PropTypes.func,
  onPlaylistUpdate: PropTypes.func,
  signedIn: PropTypes.bool,
  toggleFollowing: PropTypes.func,
  onDuplicated: PropTypes.func,
  deleting: PropTypes.bool
}

export default PlaylistEdit
